<template>
  <div>
    <p class="from_title_new">选择生成模型</p>
    <div class="com_transparent_box" style="margin-bottom: 20px"
         :class="isUnfold===true?'com_transparent_box_unfold':''">

      <!--      更多icon-->
      <i class="el-icon-arrow-down unfold" @click="isUnfold = true" v-if="isUnfold === false"></i>
      <i class="el-icon-arrow-up unfold" @click="isUnfold = false" v-if="isUnfold === true"></i>

      <div class="model_item" :class="item.check === true?'model_item_active':''" v-for="(item,index) in model_list"
           :key="item.id" @click="choose_model(item)">
        <div class="isFree" v-show="item.id===1">免费</div>
        <div class="model_item_choose">
          <div class="dot" :class="item.check === true?'dot_active':''">
            <div class="selected" v-show="item.check === true"></div>
          </div>
          <img :src="item.image">
        </div>
        <div class="model_item_des">
          <p>{{ item.des }}</p>
        </div>
      </div>
    </div>
  </div>

</template>


<script>
export default {
  data() {
    return {
      isUnfold: false,
      model_list: [
        {
          id: 1,
          title: '百度-大模型',
          check: true,
          des: '百度-大模型：ERNIE-Speed-128K文生文大模型。生成速度适中。',
          image: require('@/assets/ai/model_1.png')
        },
        {
          id: 3,
          title: '豆包-大模型',
          check: false,
          des: '豆包-大模型：DOUBAO-LITE-128k文生文大模型。速度最快，反应时间短，可快速生成需要的内容',
          image: require('@/assets/ai/model_2.png')
        },
        {
          id: 4,
          title: 'deepseek-大模型',
          check: false,
          des: 'deepseek-大模型：deepseek-R1文生文大模型。生成速度较慢，质量相对较好。',
          image: require('@/assets/ai/model_3.png')
        },
        {
          id: 2,
          title: '百度-大模型',
          check: false,
          des: '百度-大模型：ERNIE-4.0-8K文生文大模型。生成速度适中。',
          image: require('@/assets/ai/model_1.png')
        },
      ]
    }
  },
  methods: {
    choose_model(item) {
      // 遍历 model_list，将所有元素的 check 属性设为 false
      this.model_list.forEach((element) => {
        this.$set(element, 'check', false);
      });
      // 将当前点击元素的 check 属性设为 true
      this.$set(item, 'check', true);
      this.$emit('getModelStyle', item.id)
    }
  }
}
</script>

<style scoped lang="scss">
@use '@/scss/ai';
</style>